import React from 'react';
import {
  Icon,
  IconButton,
  Pressable,
  ScreenContainer,
  SimpleStyleScrollView,
  withTheme,
} from '@draftbit/ui';
import { useIsFocused } from '@react-navigation/native';
import { Image, ImageBackground, Text, View } from 'react-native';
import * as GlobalStyles from '../GlobalStyles.js';
import ScreenSizeWarningBlock from '../components/ScreenSizeWarningBlock';
import * as GlobalVariables from '../config/GlobalVariableContext';
import Images from '../config/Images';
import palettes from '../themes/palettes';
import Breakpoints from '../utils/Breakpoints';
import * as StyleSheet from '../utils/StyleSheet';
import imageSource from '../utils/imageSource';
import useWindowDimensions from '../utils/useWindowDimensions';

const BestPracticesScreen = props => {
  const { theme, navigation } = props;
  const dimensions = useWindowDimensions();
  const Constants = GlobalVariables.useValues();
  const Variables = Constants;
  const [openedTitles, setOpenedTitles] = React.useState([]);
  const addOrRemove = (title, openedTitles) => {
    const found = openedTitles.find(item => item === title);
    if (found !== undefined) {
      return openedTitles.filter(item => item !== title);
    } else {
      return [...openedTitles, title];
    }
  };
  const isFocused = useIsFocused();
  React.useEffect(() => {
    try {
      if (!isFocused) {
        return;
      }
      if (null) {
        setOpenedTitles([].concat(null));
      }
    } catch (err) {
      console.error(err);
    }
  }, [isFocused]);

  return (
    <ScreenContainer
      hasSafeArea={false}
      scrollable={false}
      style={StyleSheet.applyWidth(
        {
          backgroundColor: {
            minWidth: Breakpoints.Laptop,
            value: palettes.Brand.Background,
          },
          flexDirection: { minWidth: Breakpoints.Laptop, value: 'row' },
          maxHeight: { minWidth: Breakpoints.Laptop, value: dimensions.height },
        },
        dimensions.width
      )}
    >
      {/* Container */}
      <>
        {!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <View
            style={StyleSheet.applyWidth(
              { flex: { minWidth: Breakpoints.Laptop, value: 1 } },
              dimensions.width
            )}
          >
            {/* View 2 */}
            <View
              style={StyleSheet.applyWidth(
                {
                  paddingLeft: { minWidth: Breakpoints.Laptop, value: 40 },
                  paddingTop: { minWidth: Breakpoints.Laptop, value: 20 },
                },
                dimensions.width
              )}
            >
              <Pressable
                onPress={() => {
                  try {
                    navigation.goBack();
                  } catch (err) {
                    console.error(err);
                  }
                }}
              >
                <Icon
                  size={24}
                  color={StyleSheet.getWidthValue(
                    [
                      {
                        minWidth: Breakpoints.Laptop,
                        value: palettes.App['App Blue Light'],
                      },
                    ],
                    dimensions.width
                  )}
                  name={'AntDesign/back'}
                />
              </Pressable>
            </View>

            <SimpleStyleScrollView
              bounces={true}
              horizontal={false}
              keyboardShouldPersistTaps={'never'}
              nestedScrollEnabled={false}
              showsHorizontalScrollIndicator={true}
              showsVerticalScrollIndicator={true}
              style={StyleSheet.applyWidth(
                { flex: { minWidth: Breakpoints.Laptop, value: 1 } },
                dimensions.width
              )}
            >
              {/* Logo */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignItems: {
                      minWidth: Breakpoints.Laptop,
                      value: 'center',
                    },
                    justifyContent: {
                      minWidth: Breakpoints.Laptop,
                      value: 'center',
                    },
                  },
                  dimensions.width
                )}
              >
                {/* Image 2 */}
                <Image
                  {...GlobalStyles.ImageStyles(theme)['Image'].props}
                  resizeMode={'contain'}
                  source={imageSource(Images['logocropped'])}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.ImageStyles(theme)['Image'].style,
                      {
                        height: [
                          { minWidth: Breakpoints.Laptop, value: 200 },
                          { minWidth: Breakpoints.Desktop, value: 200 },
                          { minWidth: Breakpoints.BigScreen, value: 250 },
                        ],
                        width: [
                          { minWidth: Breakpoints.Laptop, value: 200 },
                          { minWidth: Breakpoints.Desktop, value: 200 },
                          { minWidth: Breakpoints.BigScreen, value: 250 },
                        ],
                      }
                    ),
                    dimensions.width
                  )}
                />
              </View>
              {/* Header */}
              <View
                style={StyleSheet.applyWidth(
                  {
                    alignSelf: {
                      minWidth: Breakpoints.Laptop,
                      value: 'center',
                    },
                    marginBottom: { minWidth: Breakpoints.Laptop, value: 30 },
                    marginTop: { minWidth: Breakpoints.Laptop, value: 30 },
                  },
                  dimensions.width
                )}
              >
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Text'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextStyles(theme)['Text'].style,
                      {
                        color: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand.White,
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {
                    '"The goal of forecasting is not to predict the future but to tell you what you need to know to\ntake meaningful action in present."'
                  }
                </Text>
                {/* Text 2 */}
                <Text
                  accessible={true}
                  selectable={false}
                  {...GlobalStyles.TextStyles(theme)['Text'].props}
                  style={StyleSheet.applyWidth(
                    StyleSheet.compose(
                      GlobalStyles.TextStyles(theme)['Text'].style,
                      {
                        color: {
                          minWidth: Breakpoints.Laptop,
                          value: palettes.Brand.White,
                        },
                        textAlign: {
                          minWidth: Breakpoints.Laptop,
                          value: 'right',
                        },
                      }
                    ),
                    dimensions.width
                  )}
                >
                  {'— Paul Saffo'}
                </Text>
              </View>
              {/* Questions */}
              <View
                style={StyleSheet.applyWidth(
                  { gap: { minWidth: Breakpoints.Laptop, value: 40 } },
                  dimensions.width
                )}
              >
                {/* Overall Best Practice View */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      gap: { minWidth: Breakpoints.Laptop, value: 20 },
                    },
                    dimensions.width
                  )}
                >
                  {/* Header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flexDirection: {
                          minWidth: Breakpoints.Laptop,
                          value: 'row',
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'space-between',
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '30%' },
                      },
                      dimensions.width
                    )}
                  >
                    {/* Overall Best Practice */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 20,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Overall Best Practice'}
                    </Text>
                    <IconButton
                      onPress={() => {
                        try {
                          setOpenedTitles(
                            (() => {
                              const e = addOrRemove('overall', openedTitles);
                              console.log(e);
                              return e;
                            })()
                          );
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      size={32}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.App['App Blue Light'],
                          },
                        ],
                        dimensions.width
                      )}
                      icon={
                        openedTitles.includes('overall')
                          ? 'AntDesign/caretup'
                          : 'AntDesign/caretdown'
                      }
                      size={StyleSheet.getWidthValue(
                        [{ minWidth: Breakpoints.Laptop, value: 24 }],
                        dimensions.width
                      )}
                    />
                  </View>
                  {/* Detailed View */}
                  <>
                    {!openedTitles.includes('overall') ? null : (
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignSelf: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            backgroundColor: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['Custom White'],
                            },
                            padding: {
                              minWidth: Breakpoints.Laptop,
                              value: 20,
                            },
                            width: {
                              minWidth: Breakpoints.Laptop,
                              value: '80%',
                            },
                          },
                          dimensions.width
                        )}
                      >
                        <Text
                          accessible={true}
                          selectable={false}
                          {...GlobalStyles.TextStyles(theme)['Text'].props}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              {
                                fontFamily: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'OpenSans_500Medium',
                                },
                              }
                            ),
                            dimensions.width
                          )}
                        >
                          {'By choosing to use the '}
                          {/* Cash Planit Text */}
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['Text'].props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              dimensions.width
                            )}
                          >
                            {'CASH PLANIT '}
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                GlobalStyles.TextStyles(theme)['Text'].style,
                                dimensions.width
                              )}
                            >
                              {
                                'application, you should gain more insights into your business than ever before. Best practice is to update your income and expenses on the last day of each month or the first day of the current month, submit the update, and then change the starting month cell to the current month. All previously entered data will automatically roll forward into the appropriate month.'
                              }
                            </Text>
                          </Text>
                        </Text>
                      </View>
                    )}
                  </>
                </View>
                {/* Income Best Practices View */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      gap: { minWidth: Breakpoints.Laptop, value: 20 },
                    },
                    dimensions.width
                  )}
                >
                  {/* Header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flexDirection: {
                          minWidth: Breakpoints.Laptop,
                          value: 'row',
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'space-between',
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '30%' },
                      },
                      dimensions.width
                    )}
                  >
                    {/* Header */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 20,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Income Best Practices'}
                    </Text>
                    <IconButton
                      onPress={() => {
                        try {
                          setOpenedTitles(addOrRemove('income', openedTitles));
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      size={32}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.App['App Blue Light'],
                          },
                        ],
                        dimensions.width
                      )}
                      icon={
                        openedTitles.includes('income')
                          ? 'AntDesign/caretup'
                          : 'AntDesign/caretdown'
                      }
                      size={StyleSheet.getWidthValue(
                        [{ minWidth: Breakpoints.Laptop, value: 24 }],
                        dimensions.width
                      )}
                    />
                  </View>
                  {/* Detailed View */}
                  <>
                    {!openedTitles.includes('income') ? null : (
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: {
                              minWidth: Breakpoints.Laptop,
                              value: 'flex-start',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Laptop,
                              value: 'row',
                            },
                            justifyContent: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            width: {
                              minWidth: Breakpoints.Laptop,
                              value: '100%',
                            },
                          },
                          dimensions.width
                        )}
                      >
                        {/* Left */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              width: {
                                minWidth: Breakpoints.Laptop,
                                value: '40%',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <ImageBackground
                            {...GlobalStyles.ImageBackgroundStyles(theme)[
                              'Image Background'
                            ].props}
                            resizeMode={'contain'}
                            source={imageSource(Images['chatlogo'])}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.ImageBackgroundStyles(theme)[
                                  'Image Background'
                                ].style,
                                {
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 26,
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)['Text'].style,
                                  {
                                    textAlign: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {
                                'What approach should I use\nto forecast my income for\nthe next year?'
                              }
                            </Text>
                          </ImageBackground>
                        </View>
                        {/* Right */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              backgroundColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['Custom Blue'],
                              },
                              borderColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['App Blue Light'],
                              },
                              borderRadius: {
                                minWidth: Breakpoints.Laptop,
                                value: 40,
                              },
                              borderWidth: {
                                minWidth: Breakpoints.Laptop,
                                value: 2,
                              },
                              marginTop: {
                                minWidth: Breakpoints.Laptop,
                                value: 75,
                              },
                              padding: {
                                minWidth: Breakpoints.Laptop,
                                value: 20,
                              },
                              width: {
                                minWidth: Breakpoints.Laptop,
                                value: '40%',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['Text'].props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              dimensions.width
                            )}
                          >
                            {
                              "In today's world, it's easy to access Al Sales forecasting tools from entities like Zoho Analytics, Anaplan, or Forecast Pro, albeit costly. Also, if you have fifteen months or more of sales history, you can perform your own ARIMA algorithm and get fairly accurate forecasts for free. Both of these approaches lack the intuition of the business owner and what they experience firsthand in the store.\n\nAs a small business owner, the most responsible approach to sales in cash-flow analysis is a conservative one. Relying on last year's numbers with a short-term (sixty-day) increase or decrease based on the current trend can be beneficial.\n\nCombined with this conservative approach, creating \"what if\" scenarios to forecast more significant increases or decreases can be a great way to make expense-related decisions."
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                  </>
                </View>
                {/* Expense Best Practices View */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      gap: { minWidth: Breakpoints.Laptop, value: 20 },
                    },
                    dimensions.width
                  )}
                >
                  {/* Header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flexDirection: {
                          minWidth: Breakpoints.Laptop,
                          value: 'row',
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'space-between',
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '30%' },
                      },
                      dimensions.width
                    )}
                  >
                    {/* Header */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 20,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Expense Best Practices'}
                    </Text>
                    <IconButton
                      onPress={() => {
                        try {
                          setOpenedTitles(addOrRemove('expense', openedTitles));
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      size={32}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.App['App Blue Light'],
                          },
                        ],
                        dimensions.width
                      )}
                      icon={
                        openedTitles.includes('expense')
                          ? 'AntDesign/caretup'
                          : 'AntDesign/caretdown'
                      }
                      size={StyleSheet.getWidthValue(
                        [{ minWidth: Breakpoints.Laptop, value: 24 }],
                        dimensions.width
                      )}
                    />
                  </View>
                  {/* Detailed View */}
                  <>
                    {!openedTitles.includes('expense') ? null : (
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: {
                              minWidth: Breakpoints.Laptop,
                              value: 'flex-start',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Laptop,
                              value: 'row',
                            },
                            justifyContent: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            width: {
                              minWidth: Breakpoints.Laptop,
                              value: '100%',
                            },
                          },
                          dimensions.width
                        )}
                      >
                        {/* Left */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              width: {
                                minWidth: Breakpoints.Laptop,
                                value: '40%',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <ImageBackground
                            {...GlobalStyles.ImageBackgroundStyles(theme)[
                              'Image Background'
                            ].props}
                            resizeMode={'contain'}
                            source={imageSource(Images['chatlogo'])}
                            style={StyleSheet.applyWidth(
                              StyleSheet.compose(
                                GlobalStyles.ImageBackgroundStyles(theme)[
                                  'Image Background'
                                ].style,
                                {
                                  padding: {
                                    minWidth: Breakpoints.Laptop,
                                    value: 26,
                                  },
                                }
                              ),
                              dimensions.width
                            )}
                          >
                            <Text
                              accessible={true}
                              selectable={false}
                              {...GlobalStyles.TextStyles(theme)['Text'].props}
                              style={StyleSheet.applyWidth(
                                StyleSheet.compose(
                                  GlobalStyles.TextStyles(theme)['Text'].style,
                                  {
                                    textAlign: {
                                      minWidth: Breakpoints.Laptop,
                                      value: 'center',
                                    },
                                  }
                                ),
                                dimensions.width
                              )}
                            >
                              {
                                'What should I consider\nwhen populating my\nmonthly expenses?'
                              }
                            </Text>
                          </ImageBackground>
                        </View>
                        {/* Right */}
                        <View
                          style={StyleSheet.applyWidth(
                            {
                              backgroundColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['Custom Blue'],
                              },
                              borderColor: {
                                minWidth: Breakpoints.Laptop,
                                value: palettes.App['App Blue Light'],
                              },
                              borderRadius: {
                                minWidth: Breakpoints.Laptop,
                                value: 40,
                              },
                              borderWidth: {
                                minWidth: Breakpoints.Laptop,
                                value: 2,
                              },
                              marginTop: {
                                minWidth: Breakpoints.Laptop,
                                value: 75,
                              },
                              padding: {
                                minWidth: Breakpoints.Laptop,
                                value: 20,
                              },
                              width: {
                                minWidth: Breakpoints.Laptop,
                                value: '40%',
                              },
                            },
                            dimensions.width
                          )}
                        >
                          <Text
                            accessible={true}
                            selectable={false}
                            {...GlobalStyles.TextStyles(theme)['Text'].props}
                            style={StyleSheet.applyWidth(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              dimensions.width
                            )}
                          >
                            {
                              "Suppose you have your itemized monthly profit-and-loss statement for the prior twelve-month period. In that case, you can add the monthly expenses as they occurred last year unless you are aware of an increase in any line item. If so, use the higher cost moving forward.\n\nIf you only have an annual profit-and-loss statement, you can use the annual expense divided by twelve for each month. This less accurate and only recommended if you can't retrieve the monthly data.\n\nIt's recommended that you remove any outliers. Creating an unexpected-expense-reserve line item is also recommended. This should be the average of unexpected expenses incurred over the past two or three years. If you don't have this history, use 1-1.5 percent of sales as a starting point."
                            }
                          </Text>
                        </View>
                      </View>
                    )}
                  </>
                </View>
                {/* Final Thoughts */}
                <View
                  style={StyleSheet.applyWidth(
                    {
                      alignItems: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                      gap: { minWidth: Breakpoints.Laptop, value: 20 },
                    },
                    dimensions.width
                  )}
                >
                  {/* Header */}
                  <View
                    style={StyleSheet.applyWidth(
                      {
                        alignItems: {
                          minWidth: Breakpoints.Laptop,
                          value: 'center',
                        },
                        flexDirection: {
                          minWidth: Breakpoints.Laptop,
                          value: 'row',
                        },
                        justifyContent: {
                          minWidth: Breakpoints.Laptop,
                          value: 'space-between',
                        },
                        width: { minWidth: Breakpoints.Laptop, value: '30%' },
                      },
                      dimensions.width
                    )}
                  >
                    {/* Header */}
                    <Text
                      accessible={true}
                      selectable={false}
                      {...GlobalStyles.TextStyles(theme)['Text'].props}
                      style={StyleSheet.applyWidth(
                        StyleSheet.compose(
                          GlobalStyles.TextStyles(theme)['Text'].style,
                          {
                            color: {
                              minWidth: Breakpoints.Laptop,
                              value: palettes.App['App Blue Light'],
                            },
                            fontSize: {
                              minWidth: Breakpoints.Laptop,
                              value: 20,
                            },
                          }
                        ),
                        dimensions.width
                      )}
                    >
                      {'Final Thoughts'}
                    </Text>
                    <IconButton
                      onPress={() => {
                        try {
                          setOpenedTitles(addOrRemove('final', openedTitles));
                        } catch (err) {
                          console.error(err);
                        }
                      }}
                      size={32}
                      color={StyleSheet.getWidthValue(
                        [
                          {
                            minWidth: Breakpoints.Laptop,
                            value: palettes.App['App Blue Light'],
                          },
                        ],
                        dimensions.width
                      )}
                      icon={
                        openedTitles.includes('final')
                          ? 'AntDesign/caretup'
                          : 'AntDesign/caretdown'
                      }
                      size={StyleSheet.getWidthValue(
                        [{ minWidth: Breakpoints.Laptop, value: 24 }],
                        dimensions.width
                      )}
                    />
                  </View>
                  {/* Detailed View */}
                  <>
                    {!openedTitles.includes('final') ? null : (
                      <View
                        style={StyleSheet.applyWidth(
                          {
                            alignItems: {
                              minWidth: Breakpoints.Laptop,
                              value: 'flex-start',
                            },
                            flexDirection: {
                              minWidth: Breakpoints.Laptop,
                              value: 'row',
                            },
                            justifyContent: {
                              minWidth: Breakpoints.Laptop,
                              value: 'center',
                            },
                            padding: {
                              minWidth: Breakpoints.Laptop,
                              value: 20,
                            },
                            width: {
                              minWidth: Breakpoints.Laptop,
                              value: '100%',
                            },
                          },
                          dimensions.width
                        )}
                      >
                        <Text
                          accessible={true}
                          selectable={false}
                          {...GlobalStyles.TextStyles(theme)['Text'].props}
                          style={StyleSheet.applyWidth(
                            StyleSheet.compose(
                              GlobalStyles.TextStyles(theme)['Text'].style,
                              {
                                color: {
                                  minWidth: Breakpoints.Laptop,
                                  value: palettes.Brand.White,
                                },
                                fontFamily: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'Caveat_400Regular',
                                },
                                fontSize: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 24,
                                },
                                textAlign: {
                                  minWidth: Breakpoints.Laptop,
                                  value: 'left',
                                },
                              }
                            ),
                            dimensions.width
                          )}
                        >
                          {
                            'When our goal is to improve cash flow, simply put, the more conservative we can be when forecasting income and the more realistic we can be with expenses, the better our cash flow will become over time.'
                          }
                        </Text>
                      </View>
                    )}
                  </>
                </View>
              </View>
            </SimpleStyleScrollView>

            <View
              style={StyleSheet.applyWidth(
                { padding: { minWidth: Breakpoints.Laptop, value: 20 } },
                dimensions.width
              )}
            >
              <Text
                accessible={true}
                selectable={false}
                {...GlobalStyles.TextStyles(theme)['Text'].props}
                style={StyleSheet.applyWidth(
                  StyleSheet.compose(
                    GlobalStyles.TextStyles(theme)['Text'].style,
                    {
                      color: {
                        minWidth: Breakpoints.Laptop,
                        value: 'rgb(138, 138, 138)',
                      },
                      fontFamily: {
                        minWidth: Breakpoints.Laptop,
                        value: 'Inter_400Regular',
                      },
                      textAlign: {
                        minWidth: Breakpoints.Laptop,
                        value: 'center',
                      },
                    }
                  ),
                  dimensions.width
                )}
              >
                {'Need additional help contact us - support@cashplanit.com'}
              </Text>
            </View>
          </View>
        )}
      </>
      <>
        {!!(dimensions.width >= Breakpoints.Laptop) ? null : (
          <ScreenSizeWarningBlock />
        )}
      </>
    </ScreenContainer>
  );
};

export default withTheme(BestPracticesScreen);
